<template>
    <div class="position_container register">
            <div class="position_back_button backButtonOne" v-if="showOtpField">
                <button class="btn-back btn w-45px mt-15 mb-15" @click="clearAadhaarField">
                    <v-icon class="material-icons-round"> arrow_back </v-icon>
                </button>
            </div>
        <div class="register--container">
            <div class="aadhaarVerification">
                <ValidationObserver slim v-slot="{ invalid }">
                    <div class="otpFlow" v-if="!isOcr">
                        <div class="register__form">
                            <p v-if="!showOtpField" class="register--title mb-0">Aadhaar number</p>
                            <p v-if="!showOtpField" class="register--subtitle">Please enter your Aadhaar Number</p>
                            <ValidationProvider name="Aadhaar No." rules="required|aadhaar" v-slot="{ errors, classes }">
                                <div v-if="!showOtpField" class="input-group mb-5" :class="classes">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">
                                            <img src = "/img/aadhaar_onBoarding.svg">
                                        </span>
                                    </div>
                                    <input type="text" class="form-control space"
                                        maxLength="14"
                                        placeholder="3212 3312 6784"
                                        v-model="aadhaarNo"
                                        :disabled="disableOtpField"
                                        @keydown="validateAadhaar"
                                    >
                                </div>
                                <small v-if="!showOtpField" class="form-group--error-message">{{ errors[0] }}</small>
                            </ValidationProvider>
                            <div class="bottom" v-if="showOtpField">
                                <ValidationProvider name="OTP" rules="digits:6|required" v-slot="{ errors, classes }">
                                    <p class="register--title mb-0">Verify</p>
                                    <p class="register--subtitle">Please verify your Aadhaar number</p>
                                    <div class="otp-input-wrap mb-5">
                                        <div class="otpWidth otp-input-wrap mb-5" :class="classes">
                                            <v-otp-input
                                            v-model="otp"
                                            type="number"
                                            @finish= "confirmOtp">
                                            </v-otp-input>
                                        </div>
                                    </div>
                                    <small class="form-group--error-message">{{ errors[0] }}</small>

                                    <div class="otp">
                                        <p class="otp--resend rightAlign" v-if="!otpTime">
                                        Did not receive OTP? <a @click="receiveOtp" class="ml-5"> Resend </a>
                                        </p>

                                        <p class="otp--timer rightAlign" v-else>
                                            You can resend the OTP in {{otpTime}} sec
                                        </p>
                                    </div>
                                </ValidationProvider>
                            </div>
                        </div>

                        <div v-if="!showOtpField" style="display: flex; justify-content: center; align-items: center" class="register__form--referral-bottom">
                            <button class="aadhaar-step1 btn_new btn-secondary-new w-80 mt-15 mb-15" @click="submitAadhaar" :disabled="isButtonDisabled(invalid)">Submit </button>
                        </div>
                        <div v-else style="display: flex; justify-content: center; align-items: center" class="register__form--referral-bottom">
                            <button class="aadhaar-step2 btn_new btn-secondary-new w-80 mt-15 mb-15" @click="submitAadhaar" :disabled="isButtonDisabled(invalid)">Submit </button>
                        </div>
                        <div class = "aadhaarImage" v-if="!otpTime && showOtpField">
                            <p class="hover otp--resend mt-20">
                                Still you haven't received your OTP?<a  @click="enableOcr" class="ml-5"> Upload</a>
                            </p>
                        </div>

                        <div>
                            <div class="register--or">
                                <span>or</span>
                            </div>
                            <div style="display: flex; justify-content: center; align-items: center">
                                <div style="width: 310px; border-radius: 8px; height: 38px" class="forhove uploadAadhaar" @click="enableOcr">
                                Upload Aadhaar Images
                                </div>
                            </div>
                        </div>

                    </div>
                </ValidationObserver>
                <AadhaarOcr
                    v-if="isOcr"
                    @success="success"
                />
                <v-snackbar
                    v-model="isOtpFailure"
                    app
                    timeout="-1"
                >
                        {{failureText}}

                    <template v-slot:action="{ attrs }">
                        <v-btn
                            color="red"
                            text
                            v-bind="attrs"
                            @click="isOtpFailure = false"
                        >
                        Close
                        </v-btn>
                    </template>
                </v-snackbar>
            </div>
        </div>
    </div>
</template>

<script>
import onboardingService from '@/services/lenderOnboardingService'
import AadhaarOcr from './aadhaarOcr.vue'
const { isDate } = require('@/util/util.js')

export default {
    name: 'AadhaarVerification',
    components: {
        AadhaarOcr
    },
    data () {
        return {
            aadhaarNo: '',
            disableOtpField: false,
            otp: '',
            showOtpField: false,
            isOcr: false,
            pinLength: 6,
            otpTime: 0,
            isAadhaarFileFailure: false,
            isOtpFailure: false,
            otpErrorCount: 0,
            failureText: 'Something went wrong',
            isTryOcr: false,
            disableSubmitButton: false
        }
    },
    watch: {
        otpTime: {
            handler (value) {
                if (value > 0) {
                    setTimeout(() => {
                        this.otpTime--
                    }, 1000)
                } else {
                    this.otpTime = 0
                }
            },
            immediate: true // This ensures the watcher is triggered upon creation
        },
        otp: {
            handler (value) {
                if (value.length === 6) {
                    this.submitAadhaar(value)
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        validateAadhaar (e) {
            if (!((e.keyCode >= 48 && e.keyCode <= 57) || e.keyCode === 8 || e.keyCode === 32)) {
                e.preventDefault()
            }
            if (e.keyCode !== 8) {
                if (this.aadhaarNo.length === 4 || this.aadhaarNo.length === 9) {
                    this.aadhaarNo = this.aadhaarNo += ' '
                }
            }
        },
        receiveOtp () {
            this.otp = ''
            this.submitAadhaar()
        },
        confirmOtp (otp) {
            this.otp = otp
        },
        isButtonDisabled (invalid) {
            return invalid || this.disableSubmitButton
        },
        submitAadhaar (otp) {
            this.aadhaarNo = this.aadhaarNo.replaceAll(' ', '')
            if (this.aadhaarNo.length === 12 && otp && otp.length === 6) {
                this.submitOtp(otp)
            } else if (this.aadhaarNo.length === 12) {
                this.$store.commit('isLoading')
                // call aadhaar digilocker
                const payload = {
                    consent: 'Y',
                    aadhaarNo: this.aadhaarNo,
                    ipAddress: '127.0.0.1'
                }
                onboardingService.getAadhaarOtp(payload).then((res) => {
                    if (res.status === 200) {
                        this.showOtpField = true
                        this.disableOtpField = true
                        this.otpTime = 50
                    } else if (res.status === 400) {
                        this.isOtpFailure = true
                        this.isTryOcr = true
                        this.otpErrorCount++
                        // this.aadhaarNo = this.aadhaarNo.replace(/(\d{4})(\d{4})?(\d{4})?/, '$1 $2 $3').trim()
                        this.failureText = 'Please check your Aadhaar Number'
                    } else if (res.status === 428) {
                        this.clearAadhaarField()
                        this.isOtpFailure = true
                        this.otpErrorCount++
                        this.isTryOcr = true
                        this.failureText = 'Aadhaar is not linked with any mobile number! Try uploading Aadhaar Images instead'
                    } else if (res.status === 429) {
                        this.clearAadhaarField()
                        this.isOtpFailure = true
                        this.isTryOcr = true
                        this.failureText = 'Maximum Retries Exceeded! Please upload Aadhaar Images instead or try again after 5 minutes.'
                    } else {
                        this.clearAadhaarField()
                        this.isOtpFailure = true
                        this.isTryOcr = true
                        this.otpErrorCount++
                        this.failureText = 'Something went wrong! Try uploading Aadhaar Images instead'
                    }
                    this.$store.commit('isNotLoading')
                }).catch(() => {
                    this.$store.commit('isNotLoading')
                    this.clearAadhaarField()
                })
            }
        },
        clearAadhaarField () {
            this.aadhaarNo = ''
            this.isOcr = false
            this.showOtpField = false
            this.disableOtpField = false
            this.otp = ''
            this.otpTime = 1
        },
        submitOtp (otp) {
            // call otp api
            this.$store.commit('isLoading')
            this.disableSubmitButton = true
            const payload = {
                consent: 'Y',
                aadhaarNo: this.aadhaarNo,
                otp: otp
            }
            onboardingService.verifyAadhaarOtp(payload).then((res) => {
                if (res.status === 200) {
                    if (isDate(res.data.dob)) {
                        this.$store.dispatch('onBoarding/setField', { field: 'dob', value: res.data.dob })
                    }
                    this.$store.dispatch('onBoarding/setField', { field: 'Aadhaar', value: res.data.aadhaarNumber })
                    this.$store.dispatch('onBoarding/setField', { field: 'Name', value: res.data.aadhaarName })
                    this.$store.dispatch('setUserName', res.data.aadhaarName)

                    this.success()
                } else if (res.status === 400) {
                    this.isOtpFailure = true
                    this.disableSubmitButton = false
                    this.isTryOcr = true
                    this.isAadhaarFileFailure = true
                    this.failureText = 'Invalid OTP'
                } else if (res.status === 429) {
                    this.clearAadhaarField()
                    this.disableSubmitButton = false
                    this.isOtpFailure = true
                    this.isTryOcr = true
                    this.failureText = 'Maximum Retries Exceeded! Please upload Aadhaar Images instead or try again after 5 minutes.'
                } else {
                    this.showOtpField = false
                    this.disableOtpField = false
                    this.disableSubmitButton = false
                    this.otpTime = 1
                    this.otp = ''
                    otp = ''
                    this.isOtpFailure = true
                    this.isTryOcr = true
                    this.isAadhaarFileFailure = true
                    this.failureText = 'Something went wrong. Please try again!'
                }
                this.otp = ''
                otp = ''
                this.$store.commit('isNotLoading')
            }).catch((err) => {
                console.log('error', err)
                this.isOtpFailure = true
                this.isTryOcr = true
                this.otp = ''
                otp = ''
                this.isAadhaarFileFailure = true
                this.failureText = 'Something went wrong. Please try again!'
                this.$store.commit('isNotLoading')
            })
        },
        enableOcr () {
            this.isOcr = true
            this.showOtpField = true
            this.isTryOcr = false
        },
        success () {
            this.$emit('success')
        }
    }
}
</script>
<style lang="scss" scoped>
    @import "~@/sass/components/registration-flow.scss";
    .aadhaar-step1 {
    }
    .aadhaar-step2 {
    }
    .upload-aadhar {
        small {
            font-size: $font-size-xxs;
            font-weight: $font-weight-medium;
            margin-bottom: 5px;
            display: block;
            color: $grey-medium;
        }
        &--front,
        &--back {
            border: 1px solid $grey-bullet;
            border-radius: 6px;
            background-color: $white;
            box-shadow: 0 2px 5px rgba($black, .10);
            padding: 20px 10px;
            width: 50%;
            cursor: pointer !important;

            &--img {
                height: 200px !important;
                width: 50%;

                img {
                    height: 100%;
                    width: 100%;
                }
            }

            @media (max-width: 400px) {
                &--img {
                    display: none
                }

                &--img.active {
                    display: block
                }
            }
        }

        &--btn {
            @include flex(flex, center, space-between);
            width: 100%;
            color: $black;
            font-weight: $font-weight-bold;
            font-size: $font-size-base;
        }
    }
    .aadhaarVerification {
        position: relative;
        top: 0px;
        .register__form--referral-bottom {
            margin-top: 30px;
        }
    }

    .otp-input-wrap {
        justify-content: space-around;
    }

    .uploadedFile {
        background-color: $primary;
        color: white;
        &--btn {
            color: $white !important;
        }
    }

    .backButton {
        position: absolute;
        left: -80px;
        top: -12px;
    }

    .uploadAadhaar {
        border-radius: 4px;
        background-color: #fff;
        padding: 20px;
        border: 1.5px solid #e0e0e0;
        color: #232434;
        font-weight: 500;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.875rem;
        transition: all 0.3s ease-in;
        cursor: pointer;

        .aadhaarIcon {
            transform: scale(1.3);
            margin-right: 12px;
        }
    }

    @media (max-width: 990px) {
        .aadhaarVerification {
        position: relative;
        top: 20px !important;
        .register__form--referral-bottom {
            margin-top: 30px;
        }
    }
        .backButton {
            position: unset;
        }
    }
    ::placeholder {
        color: #e0e0e0
    }
    .position_container {
        position: relative
    }

    .position_back_button {
        z-index: 1;
        position: absolute;
        top: 0px
    }
    .forhove {
  &:hover {
        background-color: #002fa7;
        color: #fff;
  }
}
    .aadhaarImage {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    ::v-deep .v-text-field--outlined > .v-input__control > .v-input__slot {
        min-height: 45px;
        max-width: 45px;
    }
    .otpWidth {
        width: 385px
    }
    @media (max-width: 990px) {
        .otpWidth {
            width: 340px
            }
    }
</style>
